/**
 * Global.js
 *
 * Global theme interactions. Codekit app is used for compiling.
 *
 * @codekit-prepend "../vendor/lodash.js"
 * @codekit-prepend "../vendor/q.js"
 * @codekit-prepend "../vendor/dropit.js"
 * @codekit-prepend "../vendor/jquery.cycle2.js"
 * @codekit-prepend "../vendor/jquery.cycle2.carousel.js"
 */
( function boot( $, _, $q ) {
	'use strict';

	var app = {};

	// Initialize
	app.init = function() {
		this.carousel();
		this.dropdowns();
		this.contentEnhancements();
	};


	// Content enhancements
	app.contentEnhancements = function() {

		// Vertically align slider captions
		$( window ).on( 'load', function() {
			$( '.section-slideshow .elementor-image-carousel-caption' ).each( function() {
				var height = $( this ).outerHeight( true );
				var offset = '-' + _.round( height / 2 ) + 'px';
				console.log( offset );
				$( this ).css( 'margin-top', offset );
			} );
		} );
	};

	// Dropdown menus
	app.dropdowns = function() {

		// Align menus
		$( document ).on( 'ready', function() {
			$( '.menu .sub-menu' ).each( function() {
				var width = $( this ).outerWidth( true );
				var offset = '-' + ( width / 2 ) + 'px';
				$( this ).css( 'margin-right', offset );
			} );
		} );

		$( '.menu' ).dropit();
	};

	// Carousel
	app.carousel = function() {
		var $elem = $( '.carousel' );

		if ( !$elem.length ) return;

		$elem.cycle( {
			fx: 'fade',
			timeout: 6000,
			speed: 1000,
			log: false,
			manualSpeed: 300,
			pager: '.carousel__pager',
			slides: '> article'
		} );
	};

	app.init();

} )( window.jQuery, window._, window.Q );
